import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import React from "react";
import AdminAlertsTable from "./AdminAlertsTable";
// import AdminAlertsTable from '../../components/adminAlerts/AdminAlertsTable';

const AdminAlertsPage = () => {
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <NotificationsActiveIcon sx={{ color: "#fff", fontSize: 32 }} />
        <Box>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
            Admin Alerts
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
            Manage and monitor all symbol alerts
          </Typography>
        </Box>
      </Box>

      {/* ADMIN ALERTS SYMBOL TABLE HERE */}
      <Box
        sx={{
          background: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        <AdminAlertsTable />
      </Box>
    </Box>
  );
};

export default AdminAlertsPage;
